<template>
  <v-container>
    <v-row justify="center" align="center" class="ma-0 pa-0" v-if="currentGallery !== null">
      <v-col>
        <div class="display-1">{{currentGallery.title}} </div>
        <div class="title">{{currentGallery.dt_start}}{{  currentGallery.dt_end !== currentGallery.dt_start?'-'+ currentGallery.dt_end : ''}} </div>
      </v-col>
    </v-row>
   <!--    <v-row mb-4 justify="center" align="center">
        <v-col cols="8" class=" black--text">

              <v-card class="mt-3">
        <v-container fluid>
          <v-row >
            <v-col
              v-for="n in 16"
              :key="n"
              class="d-flex child-flex"
              cols="4"

            >

        <v-hover
            v-slot:default="{ hover }"
            open-delay="100"
          >
              <v-card 
              flat 
              tile 
              class="d-flex"
              :elevation="hover ? 16 : 2"
              @click="gotoGallery(`gl-`+n)"
              >
                <v-img
                  :src="`https://picsum.photos/300/300?image=${n * 12 + 7}`"
                  aspect-ratio="1.7"
                  class="grey lighten-2"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out grey darken-1 v-card--reveal title white--text"
                      style="height: 100%;"
                    >
                      Дата: 24 февраля 2020 г
                    </div>
                  </v-expand-transition>                
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

        </v-col>
      </v-row> 
   <v-divider></v-divider>-->

    <vue-masonry-wall :items="currentGallery.images" :options="optionsMassonry"   @append="append" v-if="currentGallery !== null">
      <template v-slot:default="{item}">

        <v-hover
            v-slot:default="{ hover }"
            open-delay="100"
          >
              <v-card 
              flat 
              tile 
              :elevation="hover ? 12 : 2"
              @click="gotoGallery(item.id)"
              >
              <v-row class="ma-0">
                <v-col>
<!-- 
                <v-img
                  :src="`http://api.trcgagarinsky.ru/`+item.image"
                  class="grey lighten-2"
                > -->
                <img class="imgheadgal" :src="`http://api.trcgagarinsky.ru/`+item.image"/>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
               <!--  </v-img>  -->                 
                </v-col>

                </v-row>
<!--                 <div class="title">{{item.title}}</div>
                <p class="px-2 pb-4 mb-1">{{item.content}}</p> -->
              </v-card>
            </v-hover>



      </template>
    </vue-masonry-wall>

<SelectGalleryPhotoDialog :selectGallery="currentGallery" :numStartSlide="currNumSlide" v-if="showDialogGal" />
  </v-container>
</template>

<script>

import SelectGalleryPhotoDialog from '@/components/SelectGalleryPhotoDialog'
import VueMasonryWall from "vue-masonry-wall";
import axios from "axios"

export default {
  name: 'SingleGallery',
  components: {
    VueMasonryWall,
    SelectGalleryPhotoDialog
    },
  data: () => ({
    currNumSlide:0,
    items: [
/*           {id:'gal-0',title: '14/02/2020', content: 'Валентинов день в ТРЦ',urlimg:'https://picsum.photos/200/300?random37'},
          {id:'gal-1',title: '01/01/2020 - 14/01/2020', content: 'Новогодние и Рождественские праздники',urlimg:'https://picsum.photos/300/150?random12'}, */
        ],
    optionsMassonry: {
      width: 300,
      padding: {
        default: 12,
        1: 6,
        2: 8
      }

    }
  }),
  methods: {
      append() {
        const vApp = this;
        for (let i = 0; i < 10; i++) {
          this.items.push({id:'gal-'+i,title: `Item ${this.items.length}`, content: 'Content',urlimg:'https://picsum.photos/'+vApp.randW+'/'+(Math.floor(Math.random() * (600 - 20 + 1)) + 20)+'?random'+i})
        }
      },
    gotoGallery(idGal){
      const vApp = this;
      if(DEBUG) console.log('Gallery vApp.currentGallery.images :', vApp.currentGallery.images);
      if(DEBUG) console.log('idGalPhoto :', idGal);
      vApp.currNumSlide = vApp.currentGallery.images.findIndex(fim=>fim.id==idGal);
      if(DEBUG) console.log('vApp.currNumSlide :', vApp.currNumSlide);
      vApp.showDialogGal = true;
    },
    randCol(){
      let max = 4;
      let min = 2;
      let randCols = Math.floor(Math.random() * (max - min + 1)) + min;
      if(DEBUG) console.log('randCols :', randCols);
      return randCols;
    },    
   
  },
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
        currBreadcrumb: {
          get () {
            return this.$store.state.breadcrumb.currBreadcrumb;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setBreadcrumb', val)
          }
        },
        showDialogGal: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.showDialogGal);
            return this.$store.state.app.showDialogGal;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setShowDialogGal', val)
          }
        },
        currentGallery: {
          get () {
            return this.$store.state.gallery.currentGallery;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentGallery', val)
          }
        },    
        gallery: {
          get () {
            return this.$store.state.gallery.gallery;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setGallery', val)
          }
        },
        titleInner: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        },
        randW(){
          let max = 300;
          let min = 100;
          let randCols = Math.floor(Math.random() * (max - min + 1)) + min;
          if(DEBUG) console.log('randCols :', randCols);
          return randCols;
        },    
        randH(){
          let max = 800;
          let min = 100;
          let randHeight = Math.floor(Math.random() * (max - min + 1)) + min;
          if(DEBUG) console.log('randH :', randHeight);
          return randHeight;
        },         
  },

  mounted () {    

    let vApp = this
    this.$nextTick(function () {
      
      if(DEBUG) console.log('mounted Single Gallery');
    //  vApp.titleInnert = 'Фотогалерея';

          if(vApp.currentGallery === null){
            axios({
                  method: "get",
                  url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_galleries"

                })
                  .catch(function(error) {
                    if(DEBUG) console.log("ERROR: ", error);
                  })
                  .then( function(response) {
                      if(DEBUG) console.log("response dataAll Gallery = ",response.data );
                      vApp.gallery = response.data;
                      vApp.currentGallery = vApp.gallery.find(fg=>fg.slug === vApp.$route.params.idGallery);
                      vApp.currBreadcrumb[2].text = vApp.currentGallery.title;
                      vApp.titleInner = vApp.currentGallery.title;
                      vApp.$store.dispatch("setBreadcrumb",vApp.currBreadcrumb);
                    }); 
          }
          else{
                  vApp.currBreadcrumb[2].text = vApp.currentGallery.title;
                  vApp.titleInner = vApp.currentGallery.title;
                  vApp.$store.dispatch("setBreadcrumb",vApp.currBreadcrumb);
          }


    })
  }

};
</script>

<style  scoped>
.imgheadgal{
  width: 100%;
}
</style>
